import type { Locale } from "./config";
import { es, type Dictionary } from "./es";
import { en } from "./en";
import { pt } from "./pt";

export * from "./config";
export * from "./routes";
export * from "./format";
export type { Dictionary } from "./es";

const dictionaries: Record<Locale, Dictionary> = { es, en, pt };

/** The UI dictionary of a language: `t(locale).nav.compare`. */
export function t(locale: Locale): Dictionary {
  return dictionaries[locale];
}
